import { useEffect, useState, useCallback } from 'react'
import { useSearchParams } from 'react-router-dom'
import { adminService } from 'core/services/adminService'
import { UserCard } from './user-card'
import { UserDetails } from './user-details'

import c from './assets/sass/users-list.module.scss'

export const UsersList = () => {
    const [users, setUsers] = useState([])
    const [loading, setLoading] = useState(true)
    const [page, setPage] = useState(1)
    const [total, setTotal] = useState(0)
    const [search, setSearch] = useState('')
    const [selectedUser, setSelectedUser] = useState(null)
    const [sortBy, setSortBy] = useState('createdAt')
    const [sortOrder, setSortOrder] = useState('desc')
    const [searchParams] = useSearchParams()

    const loadUserById = useCallback(async (userId) => {
        try {
            const data = await adminService.getUserDetails(userId)
            if (data.user) {
                setSelectedUser(data.user)
            }
        } catch (error) {
            console.error('Failed to load user:', error)
        }
    }, [])

    const loadUsers = useCallback(async () => {
        try {
            setLoading(true)
            const data = await adminService.getUsers({
                page,
                limit: 20,
                search,
                sortBy,
                sortOrder,
            })
            setUsers(data.users)
            setTotal(data.pagination.total)
        } catch (error) {
            console.error('Failed to load users:', error)
        } finally {
            setLoading(false)
        }
    }, [page, search, sortBy, sortOrder])

    useEffect(() => {
        const userIdFromQuery = searchParams.get('userId')
        if (userIdFromQuery && !selectedUser) {
            loadUserById(userIdFromQuery)
        }
    }, [searchParams, selectedUser, loadUserById])

    useEffect(() => {
        loadUsers()
    }, [loadUsers])

    const handleSearch = (e) => {
        e.preventDefault()
        setPage(1)
        loadUsers()
    }

    if (selectedUser) {
        return (
            <UserDetails
                user={selectedUser}
                onBack={() => setSelectedUser(null)}
            />
        )
    }

    return (
        <div className={c.component}>
            <form onSubmit={handleSearch} className={c.search}>
                <input
                    type="text"
                    placeholder="Поиск по TG ID, username, siteId..."
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                />
                <button type="submit">🔍</button>
            </form>
            <div className={c.filters}>
                <select
                    value={sortBy}
                    onChange={(e) => {
                        setSortBy(e.target.value)
                        setPage(1)
                    }}
                >
                    <option value="createdAt">По дате регистрации</option>
                    <option value="lastActiveAt">По активности</option>
                    <option value="balance">По балансу</option>
                    <option value="referrals_count">
                        По количеству рефералов
                    </option>
                    <option value="referral_level">По уровню рефералки</option>
                    <option value="level">По уровню игрока</option>
                </select>
                <select
                    value={sortOrder}
                    onChange={(e) => {
                        setSortOrder(e.target.value)
                        setPage(1)
                    }}
                >
                    <option value="desc">По убыванию</option>
                    <option value="asc">По возрастанию</option>
                </select>
            </div>
            <div className={c.stats}>Всего пользователей: {total}</div>
            {loading ? (
                <div className={c.loading}>Загрузка...</div>
            ) : (
                <>
                    <div className={c.list}>
                        {users.map((user) => (
                            <UserCard
                                key={user.id}
                                user={user}
                                onClick={() => setSelectedUser(user)}
                            />
                        ))}
                    </div>
                    {total > 20 && (
                        <div className={c.pagination}>
                            <button
                                onClick={() =>
                                    setPage((p) => Math.max(1, p - 1))
                                }
                                disabled={page === 1}
                            >
                                ← Назад
                            </button>
                            <span>
                                Страница {page} из {Math.ceil(total / 20)}
                            </span>
                            <button
                                onClick={() => setPage((p) => p + 1)}
                                disabled={page >= Math.ceil(total / 20)}
                            >
                                Вперед →
                            </button>
                        </div>
                    )}
                </>
            )}
        </div>
    )
}
